import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M22 6h-5v5h-5v5h-5v5h-5","key":"svg-0"}],["path",{"d":"M6 10v-7","key":"svg-1"}],["path",{"d":"M3 6l3 -3l3 3","key":"svg-2"}]]

const IconStairsUp = createReactComponent('outline', 'stairs-up', 'StairsUp', __iconNode);

export default IconStairsUp;